import React from 'react';
import {useHistory} from "react-router-dom";
import { Divider } from 'rsuite';
import Fade from '@material-ui/core/Fade';
import {BackIcon} from '../svg/iconsSvg';
import SignUpComponent from './components/SignUpComponent';

const MySignUp = ({onForward, style}) => {

    const history = useHistory()

    const goBack = () => {
        history.goBack();
    }

    const goForward = () => {
        //onForward(11);
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head">
                <div className="head-icon" onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>Създай профил</h6>
            </div>
            <Divider />
            <SignUpComponent onForward={goForward} />
        </div>
    )
}

const SignUp = () => {
    return (
        <div style={{position: 'realtive'}}>
            <br /><br />
            <Fade in={true} timeout={{enter: 600, exit: 0}} disableStrictModeCompat={true}>
                <MySignUp />
            </Fade>
            <br /><br />
        </div>
      );
}

export default  SignUp;
